import React, { lazy, Suspense } from "react";

import { SearchResultsButton } from "./components/results-button";
import loadable from "@loadable/component";
const SearchGlobe = loadable(() => import("./components/globe"));

export const SearchResultsSection = () => {
    return (
        <div className="flex h-full flex-col items-center justify-end gap-[40px] pb-6">
            <div>
                <SearchGlobe />
            </div>
            <SearchResultsButton />
        </div>
    );
};
